class MetabaseViewModel extends Backbone.Epoxy.Model

  defaults:
    qs               : ''
    title            : null
    subtitle         : null
    isDashboard      : false

module.exports = MetabaseViewModel
